import { useId, useState } from "react";
import { TbEye, TbEyeOff } from "react-icons/tb";
import "./passwordInput.scss";

type Props = Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> & {
    inputClassName?: string;
};

export function PasswordInput({ className, inputClassName, id, ...props }: Props) {
    const autoId = useId();
    const [show, setShow] = useState(false);
    const resolvedId = id ?? `pw-${autoId}`;

    return (
        <div className={`password-input${className ? ` ${className}` : ""}`}>
            <input
                {...props}
                id={resolvedId}
                className={inputClassName}
                type={show ? "text" : "password"}
            />
            <button
                type="button"
                className="password-input__toggle"
                aria-label={show ? "Hide password" : "Show password"}
                onClick={() => setShow((s) => !s)}
                tabIndex={-1}
            >
                {show ? <TbEyeOff /> : <TbEye />}
            </button>
        </div>
    );
}

